"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingPosition = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const IsPositionOutsideOfRestrictedAreaPolygon_1 = require("../validators/IsPositionOutsideOfRestrictedAreaPolygon");
const GeoJsonGeofence_1 = require("./GeoJsonGeofence");
const LocalizedField_1 = require("./LocalizedField");
const LocationPointType_1 = require("./LocationPointType");
const Position_1 = require("./Position");
let MeetingPosition = class MeetingPosition {
    _id = (0, uuid_1.v4)();
    locationId;
    name;
    nameLocalized;
    label;
    labelLocalized;
    position;
    imageUrl;
    googleMapsUrl;
    messageToCustomer;
    messageToCustomerLocalized;
    addressType;
    displayOnlyMessageToCustomer = false;
    messageToDriver;
    policy;
    type;
    minutesFromDepartureAtEarliest;
    minutesFromDepartureAtLatest;
    restrictedAreaPolygon;
    // When set to `false`, the restrictedAreaPolygon is applied only to the pickup position
    restrictAreaForDropoff = true;
    pickupRestrictedAreaWarning;
    dropoffRestrictedAreaWarning;
    googleAddress;
    isDeleted = false;
};
exports.MeetingPosition = MeetingPosition;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MeetingPosition.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MeetingPosition.prototype, "locationId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MeetingPosition.prototype, "name", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], MeetingPosition.prototype, "nameLocalized", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MeetingPosition.prototype, "label", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], MeetingPosition.prototype, "labelLocalized", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => Position_1.Position),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.Validate)(IsPositionOutsideOfRestrictedAreaPolygon_1.IsPositionOutsideOfRestrictedAreaPolygon),
    (0, class_transformer_1.Type)(() => Position_1.Position),
    __metadata("design:type", Position_1.Position)
], MeetingPosition.prototype, "position", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (value?.trim().length ? value : undefined)),
    __metadata("design:type", String)
], MeetingPosition.prototype, "imageUrl", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (value?.trim().length ? value : undefined)),
    __metadata("design:type", String)
], MeetingPosition.prototype, "googleMapsUrl", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (value?.trim().length ? value : undefined)),
    __metadata("design:type", String)
], MeetingPosition.prototype, "messageToCustomer", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], MeetingPosition.prototype, "messageToCustomerLocalized", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], MeetingPosition.prototype, "addressType", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], MeetingPosition.prototype, "displayOnlyMessageToCustomer", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (value?.trim().length ? value : undefined)),
    __metadata("design:type", String)
], MeetingPosition.prototype, "messageToDriver", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], MeetingPosition.prototype, "policy", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], MeetingPosition.prototype, "type", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, class_validator_1.ValidateIf)((meetingPosition) => meetingPosition.minutesFromDepartureAtLatest != null),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], MeetingPosition.prototype, "minutesFromDepartureAtEarliest", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, class_validator_1.ValidateIf)((meetingPosition) => meetingPosition.minutesFromDepartureAtEarliest != null),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], MeetingPosition.prototype, "minutesFromDepartureAtLatest", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => GeoJsonGeofence_1.GeoJsonGeofence, { nullable: true }),
    (0, class_transformer_1.Expose)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", GeoJsonGeofence_1.GeoJsonGeofence)
], MeetingPosition.prototype, "restrictedAreaPolygon", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], MeetingPosition.prototype, "restrictAreaForDropoff", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (value?.trim().length ? value : undefined)),
    __metadata("design:type", String)
], MeetingPosition.prototype, "pickupRestrictedAreaWarning", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (value?.trim().length ? value : undefined)),
    __metadata("design:type", String)
], MeetingPosition.prototype, "dropoffRestrictedAreaWarning", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MeetingPosition.prototype, "googleAddress", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], MeetingPosition.prototype, "isDeleted", void 0);
exports.MeetingPosition = MeetingPosition = __decorate([
    (0, type_graphql_1.ObjectType)("MeetingPosition"),
    (0, typeorm_1.Entity)("meetingPositions")
], MeetingPosition);
//# sourceMappingURL=MeetingPosition.js.map